<template>
  <div :class="['branded-image-container', {['has-overlay']: requiresLowerCount}]">
    <div v-if="requiresLowerCount" class="branded-image__overlay">
      <p class="branded-image__overlay-text">{{targetRecipientText}}</p>
    </div>

    <div :class="['branded-image', { selected: adIsSelected}]" @click="selectAd">
      <img :src="adAttachmentUrl" class="thumbnail" />
      <p class="link"> {{ ad.advertiser_name }} </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      ad: Object,
      attachedAdId: Number,
      requiresLowerCount: Boolean,
    },

    name: 'Ad',

    computed: {
      adIsSelected: function () {
        return this.ad?.id === this.attachedAdId
      },

      adAttachmentUrl: function () {
        return this.ad?.attachments[0].url
      },

      targetRecipientText: function () {
        return `target ${this.ad?.credits_left} recipients or less to send this sponsored image`
      },
    },

    methods: {
      selectAd() {
        if (this.requiresLowerCount) { return }
        this.adIsSelected ? this.$emit('removeAd') : this.$emit('selectedAd', this.ad.id, this.adAttachmentUrl)
      },
    },
  }
</script>
